import { render } from "./APTherapist.vue?vue&type=template&id=4b488f48&scoped=true"
import script from "./APTherapist.vue?vue&type=script&lang=js"
export * from "./APTherapist.vue?vue&type=script&lang=js"

import "./APTherapist.vue?vue&type=style&index=0&id=4b488f48&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b488f48"]])

export default __exports__